export const CssVars = {
  LyricFontFamily: '--byz-lyric-font-family',
  LyricFontSize: '--byz-lyric-font-size',
  LyricOffsetHorizontal: '--byz-lyric-offset-h',
  LyricOffsetVertical: '--byz-lyric-offset-v',

  NeumeFontFamily: '--byz-neume-font-family',
  NeumeFontSize: '--byz-neume-font-size',

  DropCapFontFamily: '--byz-drop-cap-font-family',
  DropCapFontSize: '--byz-drop-cap-font-size',
  DropCapColor: '--byz-drop-cap-color',
  DropCapOffsetVertical: '--byz-drop-cap-offset-v',

  SpacerWidthVareia: '--byz-spacer-width-vareia',
  SpacerWidthApostrofos: '--byz-spacer-width-apostrofos',

  ColorAccidental: '--byz-color-accidental',
  ColorAgogi: '--byz-color-agogi',
  ColorBarline: '--byz-color-barline',
  ColorFthora: '--byz-color-fthora',
  ColorGorgon: '--byz-color-gorgon',
  ColorHeteron: '--byz-color-heteron',
  ColorIsonIndicator: '--byz-color-ison-indicator',
  ColorKoronis: '--byz-color-koronis',
  ColorMartyria: '--byz-color-martyria',
  ColorMeasureNumber: '--byz-color-measure-number',
  ColorNoteIndicator: '--byz-color-note-indicator',
};
